
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMediaBackwards10s as ObiMediaBackwards10sElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-media-backwards-10s.js';
 
 
 

 
 export const ObiMediaBackwards10s = createComponent({
   react: React,
   tagName: 'obi-media-backwards-10s',
   elementClass: ObiMediaBackwards10sElement,
   events: {
     
   }
  });
 
 